import { Doughnut, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  name: "chart",
  props: ["options"],
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};



// WEBPACK FOOTER //
// ./src/js/FoodsGraphDoughnut.js